import React from "react";
import PageHero from "@/components/PageHero";
import LeadForm from "@/components/LeadForm";
import { Clock3, ShieldCheck, FileCheck2 } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function Quote() {
  const { t } = useT();
  const BENEFITS = [
    { icon: Clock3, t: t("page.quote.b1.t"), d: t("page.quote.b1.d") },
    { icon: ShieldCheck, t: t("page.quote.b2.t"), d: t("page.quote.b2.d") },
    { icon: FileCheck2, t: t("page.quote.b3.t"), d: t("page.quote.b3.d") },
  ];
  return (
    <div data-testid="page-quote">
      <PageHero
        eyebrow={t("nav.quote")}
        title={
          <>
            {t("page.quote.title.a")}{" "}
            <span className="text-[color:var(--zp-text-3)]">{t("page.quote.title.b")}</span>
          </>
        }
        subtitle={t("page.quote.sub")}
      />

      <section className="relative pb-24">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-4 space-y-4">
            {BENEFITS.map((b, i) => (
              <div key={i} data-testid={`quote-benefit-${i}`} className="zp-card p-6">
                <div className="w-10 h-10 rounded-lg bg-[color:var(--zp-bg-2)] grid place-items-center text-[color:var(--zp-cyan-3)]">
                  <b.icon size={18} strokeWidth={1.7} />
                </div>
                <h3 className="font-display text-lg tracking-tight mt-4">{b.t}</h3>
                <p className="text-[color:var(--zp-text-2)] mt-1.5 text-sm leading-relaxed">{b.d}</p>
              </div>
            ))}
          </aside>
          <div className="lg:col-span-8">
            <LeadForm source="quote" title={t("page.quote.formTitle")} />
          </div>
        </div>
      </section>
    </div>
  );
}
